import React, {
    Component
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'

import ButtonBase from "@material-ui/core/ButtonBase";

export default function LinkButton(props){
    let button = (
        <ButtonBase {...props}>
            {props.children}
        </ButtonBase>
    )
    if(props.to){
        return (
            <Link to={props.to}>
                {button}
            </Link>
        )
    }
    return button;
}